  import { ChangeDetectorRef, Component, signal } from '@angular/core';
  import { Router,RouterOutlet , NavigationStart, NavigationEnd} from '@angular/router';
  import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

  @Component({
    selector: 'app-root',
    imports: [RouterOutlet,NgxSkeletonLoaderModule],
    templateUrl: './app.html',
    styleUrl: './app.scss'
  })
  export class App {
    protected readonly title = signal('EHNOTE Portal');
  }
